<script>
import { mapGetters, mapState, mapMutations } from "vuex";

import TeamSelector from "./TeamSelector";
import SupportContactModal from "@/components/Header/SupportContactModal";

export default {
  // Included sub-components
  components: {
    TeamSelector,
    SupportContactModal,
  },

  data() {
    return {
      contractPanelPages: [
        "contracts",
        "contract",
        "contractEdit",
        "onboardNewContract",
        "contractFacilities",
        "contractFacilitiesEdit",
      ],
    };
  },

  // Mapped state values
  computed: {
    isContractPanelPage() {
      return this.contractPanelPages.includes(this.$route.name);
    },

    ...mapGetters(["authenticated"]),
    ...mapState(["user"]),
  },

  methods: {
    // Log the user out (by resetting the vuex store)
    logOut() {
      this.resetStore();
    },

    // Mapped state methods
    ...mapMutations(["resetStore"]),
  },
};
</script>

<template>
  <div class="Container">
    <b-navbar :type="null" class="Header">
      <b-container fluid>
        <b-col>
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="nav-mr">
              <b-nav-item to="/">mine.app</b-nav-item>
            </b-navbar-nav>
            <TeamSelector v-if="authenticated && !isContractPanelPage" />
            <b-navbar-nav class="ml-auto nav-mr">
              <b-nav-item-dropdown right>
                <template #text>
                  <font-awesome-icon icon="question-circle" size="sm" />
                </template>

                <b-dropdown-item to="/help">Help</b-dropdown-item>
                <b-dropdown-item v-b-modal.support-modal>
                  Contact Support
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item to="/help">
                  Terms and Conditions
                </b-dropdown-item>
                <b-dropdown-item to="/help">Privacy Policy</b-dropdown-item>
                <SupportContactModal modal-id="support-modal" />
              </b-nav-item-dropdown>
            </b-navbar-nav>
            <b-navbar-nav>
              <b-nav-item-dropdown right v-if="authenticated">
                <template #text>
                  <font-awesome-icon icon="user" size="sm" />
                </template>

                <b-dropdown-text class="User-info-item text-nowrap">
                  <div class="User-info-name">
                    {{ `${user.name}` }}
                  </div>
                  <div class="User-info-handle">@{{ user.handle }}</div>
                </b-dropdown-text>
                <b-dropdown-divider />
                <b-dropdown-item to="/account">User Settings</b-dropdown-item>
                <b-dropdown-item to="/sign-in" @click="logOut">
                  Log Out
                </b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item to="/sign-in" v-else-if="$route.name != 'signIn'">
                Log In
              </b-nav-item>
              <!-- <b-nav-item to="/sign-up" v-else>
                Sign Up
              </b-nav-item> -->
            </b-navbar-nav>
          </b-collapse>
        </b-col>
      </b-container>
    </b-navbar>
    <div class="Content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.Container {
  position: relative;
}
.Header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  padding: 0.5rem 0;
  position: fixed;
  height: 4rem;
  width: 100%;
  z-index: 100 !important;
  background-color: rgb(249, 250, 255);
}

.User-info-item .b-dropdown-text {
  color: rgba(0, 0, 0, 0.65);
}

.User-info-name {
  font-weight: 500;
}

.User-info-handle {
  font-weight: normal;
}

@media (min-width: 768px) {
  .Header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    padding: 1rem 0;
  }
}

.Content {
  height: calc(100vh - 4rem);
  width: 100%;
  margin-top: 4rem;
}
</style>
